export default {
  LOGIN_TYPE: {
    GOOGLE: 'Google',
    SPEEDBACK: 'Speedback'
  }
};
